export const lightBlueColor = "syd";
export const lightGreenColor = "tyd";
export const lightYellowColor = "uyd";
export const lightOrangeColor = "vyd";
export const lightRedColor = "wyd";
export const lightPurpleColor = "xyd";
export const blueColor = "yyd";
export const greenColor = "zyd";
export const yellowColor = "Ayd";
export const orangeColor = "Byd";
export const redColor = "Cyd";
export const purpleColor = "Dyd";
export const darkBlueColor = "Eyd";
export const darkGreenColor = "Fyd";
export const darkYellowColor = "Gyd";
export const darkOrangeColor = "Hyd";
export const darkRedColor = "Iyd";
export const darkPurpleColor = "Jyd";
export const darkerBlueColor = "Kyd";
export const darkerGreenColor = "Lyd";
export const darkerYellowColor = "Myd";
export const darkerOrangeColor = "Nyd";
export const darkerRedColor = "Oyd";
export const darkerPurpleColor = "Pyd";
export const whiteColor = "Qyd";
export const lightGrayColor = "Ryd";
export const grayColor = "Syd";
export const darkGrayColor = "Tyd";
export const darkerGrayColor = "Uyd";
export const blackColor = "Vyd";
export const cyanColor = "Wyd";
export const magentaColor = "Xyd";
export const lightCyanColor = "Yyd";
export const lightMagentaColor = "Zyd";
export const noColor = "_yd";
export const moreColor = "$yd";
export default {lightBlueColor,lightGreenColor,lightYellowColor,lightOrangeColor,lightRedColor,lightPurpleColor,blueColor,greenColor,yellowColor,orangeColor,redColor,purpleColor,darkBlueColor,darkGreenColor,darkYellowColor,darkOrangeColor,darkRedColor,darkPurpleColor,darkerBlueColor,darkerGreenColor,darkerYellowColor,darkerOrangeColor,darkerRedColor,darkerPurpleColor,whiteColor,lightGrayColor,grayColor,darkGrayColor,darkerGrayColor,blackColor,cyanColor,magentaColor,lightCyanColor,lightMagentaColor,noColor,moreColor};